var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "keep-alive",
        [
          _vm.status > 0
            ? _c("div", [_c("h3", [_vm._v(_vm._s(_vm.info))])])
            : _vm._e(),
          _vm.sheetids
            ? _c(
                "q-tabs",
                {
                  attrs: {
                    swipeable: "",
                    "two-lines": "",
                    inverted: "",
                    "no-pane-border": "",
                    align: "left"
                  },
                  model: {
                    value: _vm.tabselected,
                    callback: function($$v) {
                      _vm.tabselected = $$v
                    },
                    expression: "tabselected"
                  }
                },
                [
                  _vm._l(_vm.sheetids, function(sheetid, index) {
                    return _vm.sheets[sheetid].wwwdisabled !== 1
                      ? _c("q-tab", {
                          key: sheetid,
                          attrs: {
                            slot: "title",
                            "no-caps": "",
                            name: _vm.sheets[sheetid].name,
                            label: _vm.sheets[sheetid].name,
                            default: index === 0
                          },
                          slot: "title"
                        })
                      : _vm._e()
                  }),
                  _c(
                    "q-tab",
                    {
                      attrs: {
                        slot: "title",
                        name: "tab-b-5",
                        icon: "info_outline"
                      },
                      slot: "title"
                    },
                    [_c("q-tooltip", [_vm._v("Informacje")])],
                    1
                  ),
                  _vm._l(_vm.sheetids, function(sheetid) {
                    return _vm.sheets[sheetid].wwwdisabled !== 1
                      ? _c(
                          "q-tab-pane",
                          {
                            key: sheetid,
                            ref: "mypanes",
                            refInFor: true,
                            staticClass: "q-pa-none modal-iframe",
                            attrs: {
                              name: _vm.sheets[sheetid].name,
                              "keep-alive": ""
                            }
                          },
                          [
                            _c("icorObjectEditSheet", {
                              attrs: {
                                sheetid: sheetid,
                                tabitem: _vm.tabitem,
                                sheet: _vm.sheets[sheetid],
                                menus: _vm.menus,
                                wwwdescription: _vm.wwwdescription,
                                imgsrc: _vm.imgsrc
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  }),
                  _c(
                    "q-tab-pane",
                    {
                      staticClass: "q-pa-none modal-iframe",
                      attrs: { name: "tab-b-5", "keep-alive": "" }
                    },
                    [
                      _c("card-info", {
                        staticClass: "q-pa-none",
                        attrs: {
                          tabname: "tab-b-5",
                          mode: "job",
                          tabitem: this.tabitem,
                          jobitem: this.tabitem.tabdata
                        }
                      })
                    ],
                    1
                  )
                ],
                2
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }